import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const roleBasedNotificationsRoute: InvariantJiraRoute = {
	name: 'eoc-role-based-notifications',
	path: '/jira/settings/products/ops/role-based-notifications',
	exact: true,
};
